import { useEffect } from 'react';
import Loader from '../recVisual/Loader';
import {  C_uniformeRojo, ID_MODULO_BASE, ID_MODULO_CONSULTA_SERVIDOR } from '../constantes/generales';

import ic_logo_mg2 from '../recGraficos/ic_logo_mg2.png';

import "../estilos/CT_Contenedor.css";
import { getServer } from '../gestionDatos/getServer';
import { guardarDatoLocal, presentarLog, recuperarDatoLocal, reportarError, setFlagUpdate } from '../helpers/funciones';

const nomClase="Get_Servidor_WB";
const idModulo=ID_MODULO_CONSULTA_SERVIDOR;

let servidorDefinido="";


const Get_Servidor = ({params, modOrigen, paramOrigen, modDestino, paramDestino, definirModulo}) => {

    var respuesta = {
        datos: "",
        exito: false,
        conectado: false,
        hayDatos: false,
        mensaje: ''
    }

    useEffect(() => {
        const nomFuncion="useEffect";

        try{   

            getServer()
                                            .get("PRINCIPAL")
                                            .then((res) => {
                                                respuesta=res;
                            
                                                if(respuesta.exito){
                                                    let serverActual=recuperarDatoLocal("ServidorMarcaGolWeb");

                                                    let temp=respuesta.datos.split("|");
                                                    servidorDefinido=temp[0];
                                                    guardarDatoLocal("ServidorMarcaGolWeb",servidorDefinido);
                                                    guardarDatoLocal("ultAcceso" + idModulo,Date.now());

                                                    if(serverActual!==servidorDefinido){
                                                        modDestino=ID_MODULO_BASE;
                                                        setFlagUpdate(true);
                                                    } 

                                                    salir();
                                                }
                                                else{
                                                    getServer()
                                                    .get("ALTERNO")
                                                    .then((res) => {
                                                        respuesta=res;
                            
                                                        if(respuesta.exito){
                                                            let serverActual=recuperarDatoLocal("ServidorMarcaGolWeb");

                                                            let temp=respuesta.datos.split("|");
                                                            servidorDefinido=temp[0];
                                                            guardarDatoLocal("ServidorMarcaGolWeb",servidorDefinido);
                                                            guardarDatoLocal("ultAcceso" + idModulo,Date.now());
                                                            
                                                            if(serverActual!==servidorDefinido){
                                                                modDestino=ID_MODULO_BASE;
                                                                setFlagUpdate(true);
                                                            }                     

                                                            salir();
                                                        }
                                                        else{
                                                            guardarDatoLocal("ServidorMarcaGolWeb","");                            

                                                            salir();
                                                        }
                            
                                                    });
                                                }
                            
                                            });
            
            
            
                    


        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
            salir();
        }               

    }, [params]);

   

    const salir = () => {     
        presentarLog("Servidor recuperado: " + servidorDefinido);
        guardarDatoLocal("rutaRecursos",servidorDefinido + "recursos/");   
        definirModulo(-100, modOrigen, paramOrigen, modDestino, paramDestino);
    }


    return (
        <div className='CT_contenedorFondo' >             
                    <div className='CT_colorFondo'>
                        <div style={{display:"flex", maxWidth:"200px", minWidth:"100px", justifyContent:"center", alignItems:"center", flexWrap:"wrap"}}>
                            <img src={ic_logo_mg2} width="100%" />
                            <Loader tipo={"PARCIAL"}/>
                        </div>                    
                    </div>
                </div>
    );

};

export default Get_Servidor;